import {
  type BuyerBidV2DetailDto,
  type MinimumRequirementDto,
  MinimumRequirementResponseType,
  type BidV2MinimumRequirementResponseDto,
} from "../../../../autogen/bff-api";

export const effectiveMinimumRequirementVerdict = (
  responseType: MinimumRequirementResponseType,
  response: BidV2MinimumRequirementResponseDto | undefined,
): boolean | null =>
  responseType === MinimumRequirementResponseType.YesNo
    ? response?.answer ?? null
    : response?.buyerVerdict ?? null;

export interface BidMinimumRequirementProgress {
  fulfilled: number;
  notFulfilled: number;
  pending: number;
  reviewed: number;
  total: number;
  hasRequirements: boolean;
}

const responsesById = (detail: BuyerBidV2DetailDto) =>
  new Map((detail.bid.minimumRequirementResponses ?? []).map((r) => [r.minimumRequirementId, r] as const));

export const getBidMinimumRequirementProgress = (detail: BuyerBidV2DetailDto): BidMinimumRequirementProgress => {
  const requirements = detail.minimumRequirements ?? [];
  const byId = responsesById(detail);
  const verdicts = requirements.map((r) => effectiveMinimumRequirementVerdict(r.responseType, byId.get(r.id ?? "")));
  const fulfilled = verdicts.filter((v) => v === true).length;
  const notFulfilled = verdicts.filter((v) => v === false).length;
  const pending = verdicts.length - fulfilled - notFulfilled;
  return {
    fulfilled,
    notFulfilled,
    pending,
    reviewed: fulfilled + notFulfilled,
    total: requirements.length,
    hasRequirements: requirements.length > 0,
  };
};

export interface BidMinimumRequirementRow {
  requirement: MinimumRequirementDto;
  response: BidV2MinimumRequirementResponseDto | undefined;
}

export const getBidMinimumRequirementRows = (detail: BuyerBidV2DetailDto): BidMinimumRequirementRow[] => {
  const byId = responsesById(detail);
  return (detail.minimumRequirements ?? []).map((requirement) => ({
    requirement,
    response: byId.get(requirement.id ?? ""),
  }));
};
